import styled from '@emotion/styled';
import { DividerContainer } from '@kizen/page-builder/nodes/containers';
import { gray } from '@kizen/kds/Colors';

export const StyledDivider = styled.hr`
  border: unset;
  border-top: ${({
    borderStyle = 'solid',
    color = gray['gray-600'],
    size = '1',
  }) => `${size}px ${borderStyle} ${color}`};
  background-color: inherit;
  margin-left: 0;
  margin-right: 0;
  width: ${({ width = '100' }) => `${width}%`};
  margin: unset;
`;

export const ViewDivider = (props) => (
  <DividerContainer alignment={props.alignment} {...props}>
    <StyledDivider
      borderStyle={props.borderStyle}
      color={props.color}
      size={props.size}
      width={props.width}
    />
  </DividerContainer>
);
